import TatvamTextArea from "./tatvamTextArea";

export default TatvamTextArea;